import { gql } from "@apollo/client";

const LEAGUE_MEMBER = gql`
  query leagueMembers(
    $memberId: Int
    $memberPublicId: String
    $organization: Int
    $organizationPublicId: String
  ) {
    leagueMembers(
      memberId: $memberId
      memberPublicId: $memberPublicId
      organization: $organization
      organizationPublicId: $organizationPublicId
    ) {
      id
      league {
        id
        title
        status
      }
      role {
        id
        role {
          id
          name
        }
      }
    }
  }
`;

export default LEAGUE_MEMBER;
